import { useEffect, useMemo } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { fetchReportCollectionTemplates, selectIsReportCollectionTemplateRequestPending, selectReportCollectionTemplatesByKey } from '../../redux/reportCollectionTemplates';
// @ts-expect-error Untyped import
import { trackEvent } from '../../lib/usageTracker';
import { useDispatch, useSelector } from 'react-redux';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import { SUB_APPS } from 'reporting-data/tsTypes/subAppTypes';
// @ts-expect-error Untyped import
import { getQueryParamsObject } from '../../utils/queryStrings';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getGatesAndScopes } from '../../selectors/gatesSelector';
import { ViewerBreadcrumbs } from '../components/ViewerBreadcrumbs';
// @ts-expect-error Untyped import
import { getRealmTemplateKeys } from '../../utils/reportingIAUtils';
// @ts-expect-error Untyped import
import ReportErrorMessage from '../../components/ReportErrorMessage';
// @ts-expect-error Untyped import
import { subAppKeysByTemplateKey } from 'sales-analytics-lib/utils/get-report-config';
import GeneratedJourneySrv from '../../components/analyticsSuites/GeneratedJourneySrv';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import AsyncSingleReportViewerFullPage from 'reporting-enablement/components/singleReportViewer/AsyncSingleReportViewerFullPage';
import { SUITE_SCREEN_NAMES } from '../../constants/screenNames';
import { jsx as _jsx } from "react/jsx-runtime";
const noop = () => {};
export const TemplateViewerContainer = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const {
    tab
  } = getQueryParamsObject(history);
  const {
    collectionId,
    subAppKey
  } = useParams();
  const {
    gates,
    scopes
  } = useSelector(getGatesAndScopes);
  useEffect(() => {
    void dispatch(fetchReportCollectionTemplates());
  }, [dispatch]);
  const templatesByKey = useSelector(selectReportCollectionTemplatesByKey);
  const loading = useSelector(selectIsReportCollectionTemplateRequestPending);
  const templateKeys = getRealmTemplateKeys(subAppKey, gates, scopes);
  const templates = loading ? [] : templateKeys.map(templateKey => templatesByKey.get(templateKey));
  const template = tab ? templates.find(aTemplate => subAppKeysByTemplateKey.get(aTemplate.get('templateKey')) === tab) : templates[0];
  const isTabbedReport = templates.length > 1;
  const sharedSrvProps = useMemo(() => {
    const screenName = SUITE_SCREEN_NAMES[collectionId];
    const subAppTitleKey = `reports.suiteContents.${subAppKey}.title`;
    return {
      title: isTabbedReport && isValidI18nKey(subAppTitleKey) ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: subAppTitleKey
      }) : undefined,
      onClose: noop,
      hideBackButton: true,
      reportErrorRenderer: ReportErrorMessage,
      track: trackEvent,
      trackingApplicationName: 'reporting',
      trackingScreenName: screenName,
      trackingSubscreenName: subAppKey,
      enableReportTemplateLocalStoragePersistence: true,
      breadcrumbs: /*#__PURE__*/_jsx(ViewerBreadcrumbs, {})
    };
  }, [subAppKey, isTabbedReport, collectionId]);
  if (loading) {
    return /*#__PURE__*/_jsx(LoadingSpinner, {
      layout: "centered"
    });
  }
  if (!template) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "reports.errors.templateNotFound"
    });
  }
  if ([SUB_APPS.leadFunnel, SUB_APPS.dealJourney].includes(subAppKey)) {
    return /*#__PURE__*/_jsx(GeneratedJourneySrv, Object.assign({
      template: template,
      templates: isTabbedReport ? templates : undefined
    }, sharedSrvProps));
  }
  return /*#__PURE__*/_jsx(AsyncSingleReportViewerFullPage, Object.assign({
    report: template,
    additionalReports: isTabbedReport ? templates : undefined
  }, sharedSrvProps));
};